import io from 'socket.io-client';
import history from './history';
import actionConstants from './constants';
import auth from './auth';

import {
  creationOk as creationOkAction,
  creationFail as creationFailAction,
} from './domains/ExerciseCreate/ExerciseCreateActions';

import {
  userRenameOk as userRenameOkAction,
  userJoined as userJoinedAction,
  userLeft as userLeftAction,
  userStatusUpdate as userStatusUpdateAction,
  fetchExerciseOk as fetchExerciseOkAction,
  statusChange as statusChangeAction,
  userLocationUpdate as userLocationUpdateAction,
  textMessage as textMessageAction,
  audioMessage as audioMessageAction,
  audioMessageStatus as audioMessageStatusAction,
  setState as setStateAction,
  playStart as playStartAction,
  playPause as playPauseAction
} from './domains/Exercise/ExerciseActions';

let playTimer = null;
let setVarTimeout = null;

export function connect(cb) {
  global.socket = io.connect(`${location.protocol}//${location.host}`);

  global.socket.emit('authenticate', { token: localStorage.token });

  global.socket.on('bad_message', () => {
    global.store.dispatch({ type: actionConstants.BAD_MESSAGE });
  });

  global.socket.on('authentication_ok', () => {
    global.store.dispatch({ type: actionConstants.EXERCISES_LOADING_START });
    global.socket.emit('request_exercises');
  });

  global.socket.on('exercise_create_ok', (data) => {
    global.store.dispatch(creationOkAction(data.id));
  });

  global.socket.on('exercise_create_fail', (data) => {
    global.store.dispatch(creationFailAction(data.message));
  });

  global.socket.on('exercise_delete_ok', (id) => {
    global.store.dispatch({ type: actionConstants.EXERCISES_DELETE_OK, payload: id });
    global.store.dispatch({ type: actionConstants.EXERCISES_LOADING_END });
    // history.push('/exercises');
  });

  global.socket.on('user_rename', (data) => {
    global.store.dispatch(userRenameOkAction(data));
  });

  global.socket.on('user_status_update', (data) => {
    global.store.dispatch(userStatusUpdateAction(data));
  });

  global.socket.on('set_state', (data) => {
    global.store.dispatch(setStateAction(data.state));
  });

  global.socket.on('exercise_join_ok', (data) => {
    global.store.dispatch(fetchExerciseOkAction(data));

    if (data.playStartedAt) {
      global.store.dispatch(playStartAction(data));
    }
    else {
      global.store.dispatch(playPauseAction(data));
    }
  });

  global.socket.on('exercise_status_update', () => {
    global.store.dispatch(statusChangeAction('RUNNING'));
  });

  global.socket.on('user_joined', (data) => {
    global.store.dispatch(userJoinedAction(data));
  });

  global.socket.on('user_left', (data) => {
    global.store.dispatch(userLeftAction(data));
  });

  global.socket.on('user_location_update', (data) => {
    global.store.dispatch(userLocationUpdateAction(data));
  });

  global.socket.on('text_message', (data) => {
    global.store.dispatch(textMessageAction(data));
  });
  
  global.socket.on('audio_message_status', (data) => {
    global.store.dispatch(audioMessageStatusAction(data));
  });
  
  global.socket.on('audio_message', (data) => {
    console.log("Received audio message:", data);
    global.store.dispatch(audioMessageAction(data));
  })

  global.socket.on('exercises_list', (exercises) => {
    global.store.dispatch({ type: actionConstants.EXERCISES_UPDATE, payload: exercises });
    global.store.dispatch({ type: actionConstants.EXERCISES_LOADING_END });
  });

  global.socket.on('set_var_ok', () => {
    global.store.dispatch({ type: actionConstants.EXERCISE_VARIABLES_LOADING_END });
  });

  global.socket.on('set_var_fail', () => {
    global.store.dispatch({ type: actionConstants.EXERCISE_VARIABLES_LOADING_END });
  });

  global.socket.on('set_var', (data) => {
    global.store.dispatch({ type: actionConstants.EXERCISE_SET_VAR, payload: data, state: global.store.getState() });
    clearTimeout(setVarTimeout);
    setVarTimeout = setTimeout(global.store.dispatch.bind(this, { type: actionConstants.EXERCISE_SET_VAR_LOG, payload: data }), 200)
  });

  global.socket.on('play_start', (data) => {
    global.store.dispatch(playStartAction(data));
  });

  global.socket.on('play_pause', (data) => {
    global.store.dispatch(playPauseAction(data));
  });

  global.socket.on('play_stop', (data) => {
    global.store.dispatch(playPauseAction(data));
  });

  global.socket.on('unauthorized', () => {
    global.store.dispatch({ type: actionConstants.SOCKET_DISCONNECTED });
    auth.logoutAndRedirect();
  });

  const logout = () => {
    global.store.dispatch({ type: actionConstants.SOCKET_DISCONNECTED });
    auth.logoutAndRedirect();
  };

  global.socket.on('connect_failed', () => logout());
  global.socket.on('connect_error', () => logout());
  global.socket.on('disconnect', () => logout());

  cb();
}

export function disconnect() {
  if (global.socket) {
    global.socket.disconnect();
    global.socket = null;
  }
}
